export const baseUrl = "https://json-server-abrar-production.up.railway.app/";